// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import Raven from 'raven-js';
import VueAnalytics from 'vue-analytics'
import App from './App'
import router from './router'
import store from './store'
import * as types from './store/mutation-types'
import Vuex from 'vuex'
import 'normalize.css'
import ElementUI from 'element-ui'
import './assets/etheme/element-variables.scss'
import * as moment from 'moment/moment'
import {storejs} from './common/js/util'
import 'nprogress/nprogress.css'
import './assets/css-4/base.css'
import './assets/style.css'
import 'tachyons'
import './assets/iconfont/iconfont.css'
import './assets/iconfont/iconfont.js'
import {StorageFingerprint} from './utils/fingerprint'

import './styles/index.scss'

StorageFingerprint()

//全局配置
// Raven
//   .config('https://942cabacad364a108c2c45f51c81e5d1@sentry.io/204809',{
//     release: process.version,
//     environment: process.env.NODE_ENV
//   })
//   .install();
// Vue.config.errorHandler = function VueErrorHandler(error, vm) {
//   Raven.captureException(error, {
//     extra: {
//       componentName: formatComponentName(vm),
//       propsData: vm.$options.propsData
//     }
//   });
//   console.error("[Vue error]: "+error)
// };
// function formatComponentName (vm) {
//   if (vm.$root === vm) {
//     return 'root instance'
//   }
//   var name = vm._isVue
//     ? vm.$options.name || vm.$options._componentTag
//     : vm.name
//   return (name ? 'component <' + name + '>' : 'anonymous component') +
//     (vm._isVue && vm.$options.__file ? ' at ' + vm.$options.__file  : '')
// }

Vue.use(VueAnalytics, {
  id: 'UA-99905250-1',
  router
})
Vue.use(ElementUI)
Vue.use(Vuex)

Vue.prototype.$storejs = storejs
moment.locale('zh-cn')
Vue.prototype.$moment = moment

Vue.config.productionTip = process.env.NODE_ENV !== 'production'

// 路由配置
router.beforeEach((to, from, next) => {

  if (to.meta && to.meta.title) document.title = to.meta.title

  if (to.query.token) {
    store.dispatch('userLogout')
    store.commit(types.UPDATE_TOKEN, to.query.token)
    let query = to.query
    delete query.token
    query.q = Math.random()
    next({path: to.path, query: query})
  } else if (store.getters.token) {
    if (store.getters.userInfo) {
      next()
    } else {
      store.dispatch('auth_jwt').then(res => {
        next()
      }).catch(err => {
        if (to.matched[0].path === '/usercenter') {
          next('/')
        } else {
          next()
        }
      })
    }
  } else {
    if (to.matched[0].path === '/usercenter') {
      next('/')
    } else {
      next()
    }
  }
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js